import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "reviewleft" }
const _hoisted_4 = { class: "reviewtable" }
const _hoisted_5 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_6 = { valign: "top" }
const _hoisted_7 = { valign: "top" }
const _hoisted_8 = { valign: "top" }
const _hoisted_9 = { valign: "top" }
const _hoisted_10 = { valign: "top" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { valign: "top" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { valign: "top" }
const _hoisted_18 = { valign: "top" }
const _hoisted_19 = { valign: "top" }
const _hoisted_20 = { valign: "top" }
const _hoisted_21 = { valign: "top" }
const _hoisted_22 = { class: "reviewtable" }
const _hoisted_23 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "collapserowmobile"
}
const _hoisted_24 = { valign: "top" }
const _hoisted_25 = { valign: "top" }
const _hoisted_26 = { valign: "top" }
const _hoisted_27 = { valign: "top" }
const _hoisted_28 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_29 = { valign: "top" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { valign: "top" }
const _hoisted_32 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_33 = { valign: "top" }
const _hoisted_34 = { valign: "top" }
const _hoisted_35 = { valign: "top" }
const _hoisted_36 = { class: "reviewright" }
const _hoisted_37 = { class: "reviewtable" }
const _hoisted_38 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_39 = { valign: "top" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { valign: "top" }
const _hoisted_42 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_43 = { valign: "top" }
const _hoisted_44 = { class: "reviewtable" }
const _hoisted_45 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_46 = {
  valign: "top",
  width: "80%"
}
const _hoisted_47 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_48 = { valign: "top" }
const _hoisted_49 = { valign: "top" }
const _hoisted_50 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_51 = { valign: "top" }
const _hoisted_52 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_53 = { valign: "top" }
const _hoisted_54 = { style: {"font-size":"13px","line-height":"20px"} }
const _hoisted_55 = { style: {"text-align":"center"} }
const _hoisted_56 = ["disabled"]

import { LocalDate, DateTimeFormatter } from "@js-joda/core";
import { PaymentOptions } from "@/models/QuoteInsurance";
import {
  maskedCardNumber,
  billingDayWithOrdinal,
  formatAmount,
  calculateQuoteTotal,
} from "@/utils/Utils";
import DisclosuresModal from "@/views/modals/context/DisclosuresModal.vue";
import PaymentAuthorizationModal from "@/views/modals/context/PaymentAuthorizationModal.vue";
import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { Defaults } from "@/models/Defaults";
import { UserData } from "@/api/UserData";
import { AssurantData } from "@/api/AssurantData";
import {
  rentersNextPaymentDateFormated,
  nssiNextPaymentDateFormated,
  formatAmountWithoutCents,
} from "@/utils/Utils";
import { watch } from "vue";
import { ref, computed, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import BaseModal from "@/views/modals/BaseModal.vue";
import Modals from "@/utils/Modals";
import useModal from "@/hooks/useModal";

const title = "Review";

export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteReview',
  setup(__props) {

const { toggleModal } = useModal();

const loading = ref(false);
const issuingPolicies = ref(false);
const refName = ref(null);
const disclosuresModal = ref(null);
const paymentAuthorizationModal = ref(null);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;

watch(user, (current) => {
  if (!current.loggedIn) {
    quote.setQuoteStep("quote-account");
  }
});

async function goToPage(command: string) {
  // Re-submit protection
  if (issuingPolicies.value) {
    return;
  }

  loading.value = true;
  issuingPolicies.value = true;
  try {
    await UserData.fetchUser(); //TODO is this needed?
    if (quote.rentersInsurance && !quote.assurantPassed) {
      const result = await AssurantData.issuePolicy(quote);
      if (result.error) {
        quote.assurantPassed = false;
        quote.assurantPolicyError = result.message;
        issuingPolicies.value = false;
        quote.setQuoteStep("quote-done-assurant-failed-api");
        return;
      } else {
        quote.assurantPassed = true;
        quote.rentersInsurance.policyNumber =
          result.result.transactionDetails.policyId;
        quote.assurantPolicyError = "";
        if (result?.result?.transactionDetails?.policyId) {
          try {
            const transactionDetails = result.result.transactionDetails;
            const policyHolder = result.result.policyHolderDetails;
            const billing = result.result.billingDetails;
            await NssiData.storeAssurantPolicy(
              transactionDetails,
              policyHolder,
              billing
            );
          } catch (error) {
            // Continue execution
          }
        }
      }
    }
    if (quote.personalInsurance && !quote.nssiPassed) {
      const cartId = await NssiData.toRemote(quote);
      console.log("Cart ID:", cartId);
      const userDataAll = await NssiData.getUserData();
      console.log("User Data for NSSI:", userDataAll);
      const result = await NssiData.issuePolicy(quote, userDataAll, cartId);
      console.log("result of IssuePolicy", result);
      if (result.error) {
        quote.nssiPassed = false;
        quote.nssiPolicyError = result.message;
        //saveStorage();
      } else {
        quote.nssiPassed = true;
        quote.personalInsurance.transactionId = result.policy;
        //quote.personalInsurance.transactionId = result.policy.PolicyID;
        //quote.personalInsurance.policyNumber = result.policy.PolicyNumber;
        quote.nssiPolicyError = "";
      }
    }
  } catch (error) {
    console.log("err on Assurant or NSSI API");
    //TODO
  }
  issuingPolicies.value = false;
  let nssiCheckFlag = true;
  if (quote.personalInsurance && !quote.nssiPassed) {
    nssiCheckFlag = false;
  }
  if (quote.assurantPassed && nssiCheckFlag) {
    loading.value = false;
    quote.setQuoteStep(command);
  }
}

const rentersNextPaymentDate = computed(() => {
  return rentersNextPaymentDateFormated(quote);
});
const nssiNextPaymentDate = computed(() => {
  return nssiNextPaymentDateFormated(quote);
});

const quoteCoverage = async () => {
  quote.setQuoteStep("quote-quote");
};

function quoteCheckoutPayment() {
  quote.setQuoteStep("quote-checkout-payment");
}

function quoteCheckout() {
  quote.setQuoteStep("quote-checkout");
}

function formatDate(value: string) {
  if (value) {
    return LocalDate.parse(value).format(
      DateTimeFormatter.ofPattern("M/d/yyyy")
    );
  }
}

// function formatAmountWithoutCents(value: number): string {
//   return formatAmountWithoutCents(value);
// }

// function formatAmount(value: number): string {
//   return formatAmount(value);
// }

function formatPaymentOption(value: any) {
  const num = Number(value) as PaymentOptions;
  switch (num) {
    case PaymentOptions.Monthly:
      return "Monthly";
    case PaymentOptions.Annual:
      return "Annual";
    case PaymentOptions.FourPay:
      return "4 Pay";
    default:
      return "Unknown";
  }
}

function formatCardNumber(cardNumber: string): string {
  return maskedCardNumber(cardNumber);
}

function formatBillingDay(billingDay: number): string {
  return billingDayWithOrdinal(billingDay);
}

function showDisclosuresModal() {
  toggleModal(Modals.DISCLOSURES_MODAL.label);
}

function showPaymentAuthorizationModal() {
  toggleModal(Modals.PAYMENT_AUTHORIZATION_MODAL.label);
}

const processingFee: ComputedRef<number> = computed(() => {
  return quote.personalInsurance.paymentOption == PaymentOptions.Monthly
    ? quote.monthlyProcessingFee
    : quote.processingFee;
});

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});

function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[66] || (_cache[66] = _createElementVNode("div", {
        class: "subtitle",
        style: {"text-align":"center"}
      }, " Review Your Purchase ", -1)),
      _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, [
            _cache[6] || (_cache[6] = _createTextVNode(" Your Coverage Details ", -1)),
            _createElementVNode("a", {
              href: "",
              class: "edit",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (quoteCoverage()), ["prevent"]))
            }, "Edit")
          ]),
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", { valign: "top" }, "Policy Term", -1)),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(quote).info.policyLength) + " Year", 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", {
                  valign: "top",
                  width: "55%"
                }, "Coverage Start Date", -1)),
                _createElementVNode("td", _hoisted_7, _toDisplayString(formatDate(_unref(quote).info.coverageStartDate)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", { valign: "top" }, "Your liability", -1)),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", { valign: "top" }, "Personal Property Coverage", -1)),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .personalPropertyAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("td", { valign: "top" }, "Deductible", -1)),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails.deductible
                    )), 1)
              ]),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.hurricaneDeductible != null)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _cache[12] || (_cache[12] = _createElementVNode("td", { valign: "top" }, "Hurricane Deductible", -1)),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .hurricaneDeductible
                    )), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.replacementCost)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("td", { valign: "top" }, "Replacement Cost", -1),
                    _createElementVNode("td", { valign: "top" }, "Included", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.waterBackup)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("td", { valign: "top" }, "Water / Sewer Backup", -1),
                    _createElementVNode("td", { valign: "top" }, "Added", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.identityFraud)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("td", { valign: "top" }, "Fraud Expense Protection", -1),
                    _createElementVNode("td", { valign: "top" }, "Added", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.earthquake)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("td", { valign: "top" }, "Earthquake", -1),
                    _createElementVNode("td", { valign: "top" }, "Added", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", { valign: "top" }, "Payment Plan", -1)),
                _createElementVNode("td", _hoisted_17, _toDisplayString(formatPaymentOption(_unref(quote).rentersInsurance.paymentOption)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[18] || (_cache[18] = _createElementVNode("td", { valign: "top" }, "Accidental Damage Personal Property Add-On", -1)),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(quote).hasPersonalInsurance ? "Added" : "N/A"), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[19] || (_cache[19] = _createElementVNode("td", { valign: "top" }, " Accidental Damage Personal Property Coverage ", -1)),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(quote).hasPersonalInsurance
                      ? _unref(formatAmountWithoutCents)(
                          _unref(quote).personalInsurance.coverageAmount
                        )
                      : "N/A"), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[20] || (_cache[20] = _createElementVNode("td", { valign: "top" }, " Accidental Damage Personal Property Deductible ", -1)),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(quote).hasPersonalInsurance
                      ? _unref(quote).personalInsurance.deductibleAmountText
                      : "N/A"), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[21] || (_cache[21] = _createElementVNode("td", { valign: "top" }, " Accidental Damage Personal Property Payment Plan ", -1)),
                _createElementVNode("td", _hoisted_21, _toDisplayString(formatPaymentOption(_unref(quote).personalInsurance.paymentOption)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("h4", null, [
            _cache[22] || (_cache[22] = _createTextVNode(" Your Information ", -1)),
            _createElementVNode("a", {
              href: "",
              class: "edit",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (quoteCheckout()), ["prevent"]))
            }, "Edit")
          ]),
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[23] || (_cache[23] = _createElementVNode("td", {
                  valign: "top",
                  width: "55%"
                }, "Policyholder", -1)),
                _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(quote).checkout.info.firstName) + " " + _toDisplayString(_unref(quote).checkout.info.lastName), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[24] || (_cache[24] = _createElementVNode("td", { valign: "top" }, "Date of Birth", -1)),
                _createElementVNode("td", _hoisted_25, _toDisplayString(formatDate(_unref(quote).checkout.info.dob)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[25] || (_cache[25] = _createElementVNode("td", { valign: "top" }, "Phone Number", -1)),
                _createElementVNode("td", _hoisted_26, _toDisplayString(formatPhoneNumber(_unref(quote).checkout.info.phone)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[26] || (_cache[26] = _createElementVNode("td", { valign: "top" }, "Email", -1)),
                _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(quote).checkout.info.email), 1)
              ])
            ])
          ]),
          _cache[40] || (_cache[40] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("table", _hoisted_28, [
            _createElementVNode("tbody", null, [
              _cache[33] || (_cache[33] = _createElementVNode("tr", null, null, -1)),
              _createElementVNode("tr", null, [
                _cache[28] || (_cache[28] = _createElementVNode("td", {
                  valign: "top",
                  width: "55%"
                }, "Roommate(s)", -1)),
                _createElementVNode("td", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quote).checkout.roommates, (roommate) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: 
                      'roommate-' + _unref(quote).checkout.roommates.indexOf(roommate)
                    
                    }, [
                      _createTextVNode(_toDisplayString(roommate.firstName) + " " + _toDisplayString(roommate.lastName), 1),
                      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1))
                    ], 64))
                  }), 128))
                ])
              ]),
              (_unref(quote).checkout.interestedParty.firstName !== '')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _cache[32] || (_cache[32] = _createElementVNode("td", { valign: "top" }, "Interested Party", -1)),
                    _createElementVNode("td", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_unref(quote).checkout.interestedParty.firstName +
                    " " +
                    _unref(quote).checkout.interestedParty.lastName), 1),
                      _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.interestedParty.address.address) + " " + _toDisplayString(_unref(quote).checkout.interestedParty.address.apt
                      ? ", Apt " + _unref(quote).checkout.interestedParty.address.apt
                      : ""), 1),
                      _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.interestedParty.address.city) + ", " + _toDisplayString(_unref(quote).checkout.interestedParty.address.state.title) + " " + _toDisplayString(_unref(quote).checkout.interestedParty.address.zip), 1),
                      _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[41] || (_cache[41] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("table", _hoisted_32, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[35] || (_cache[35] = _createElementVNode("td", {
                  valign: "top",
                  width: "55%"
                }, "Property Address", -1)),
                _createElementVNode("td", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_unref(quote).address.address), 1),
                  _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(quote).address.city) + ", " + _toDisplayString(_unref(quote).address.state.title) + " " + _toDisplayString(_unref(quote).address.zip), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[37] || (_cache[37] = _createElementVNode("td", { valign: "top" }, "Mailing Address", -1)),
                _createElementVNode("td", _hoisted_34, [
                  (_unref(quote).checkout.useSameAddressForMailing)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Same as property address ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(quote).checkout.mailingAddress.streetNumber) + " " + _toDisplayString(_unref(quote).checkout.mailingAddress.address), 1),
                        _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.mailingAddress.city) + " " + _toDisplayString(_unref(quote).checkout.mailingAddress.state.title) + " " + _toDisplayString(_unref(quote).checkout.mailingAddress.zip), 1)
                      ], 64))
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[39] || (_cache[39] = _createElementVNode("td", { valign: "top" }, "School Information", -1)),
                _createElementVNode("td", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_unref(quote).checkout.schoolName), 1),
                  _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.schoolCity), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("h4", null, [
            _cache[42] || (_cache[42] = _createTextVNode(" Payment Method ", -1)),
            _createElementVNode("a", {
              href: "",
              class: "edit",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (quoteCheckoutPayment()), ["prevent"]))
            }, "Edit")
          ]),
          _createElementVNode("table", _hoisted_38, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[43] || (_cache[43] = _createElementVNode("td", {
                  valign: "top",
                  width: "55%"
                }, "Payment Type", -1)),
                _createElementVNode("td", _hoisted_39, [
                  (_unref(quote).checkout.paymentMethod.creditCard)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Credit / Debit Card ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Bank Account ")
                      ], 64))
                ])
              ]),
              (_unref(quote).checkout.paymentMethod.creditCard)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                    _cache[44] || (_cache[44] = _createElementVNode("td", { valign: "top" }, "Card Details", -1)),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(formatCardNumber(_unref(quote).checkout.paymentMethod.cardNumber)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[47] || (_cache[47] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("table", _hoisted_42, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[46] || (_cache[46] = _createElementVNode("td", {
                  valign: "top",
                  width: "55%"
                }, "Billing Address", -1)),
                _createElementVNode("td", _hoisted_43, [
                  (_unref(quote).checkout.paymentMethod.billingAddressType === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Same as property address ")
                      ], 64))
                    : (_unref(quote).checkout.paymentMethod.billingAddressType === 2)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Same as mailing address ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.streetNumber) + " " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.address), 1),
                          _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.city) + " " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.state.title) + " " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.zip), 1)
                        ], 64))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _cache[56] || (_cache[56] = _createElementVNode("h4", null, "Total", -1)),
          _createElementVNode("table", _hoisted_45, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_46, [
                  _cache[48] || (_cache[48] = _createTextVNode(" Assurant Renters Insurance Policy", -1)),
                  _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                  (_unref(quote).rentersInsurance.paymentOption != 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Your next payment of " + _toDisplayString(_unref(formatAmount)(
                        _unref(quote).rentersInsurance.installmentAmount +
                          _unref(quote).rentersInsurance.serviceFee
                      )) + " will be charged automatically on " + _toDisplayString(rentersNextPaymentDate.value) + " of the month.", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.dueToday)), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_49, [
                  _cache[50] || (_cache[50] = _createTextVNode(" NSSI Accidental Damage Personal Property Coverage Policy", -1)),
                  _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                  (_unref(quote).hasPersonalInsurance)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(quote).personalInsurance.paymentOption != 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Your next payment of " + _toDisplayString(_unref(formatAmount)(
                          _unref(quote).personalInsurance.retailPremium
                        )) + " will be charged automatically on " + _toDisplayString(nssiNextPaymentDate.value) + " of the month.", 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_51, _toDisplayString(_unref(quote).hasPersonalInsurance
                      ? _unref(formatAmount)(
                          _unref(quote).personalInsurance.dueToday
                        )
                      : "N/A"), 1)
              ])
            ])
          ]),
          _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
          _cache[58] || (_cache[58] = _createElementVNode("hr", null, null, -1)),
          _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("table", _hoisted_52, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[52] || (_cache[52] = _createElementVNode("td", { valign: "top" }, [
                  _createTextVNode(" Due Today"),
                  _createElementVNode("br"),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("td", _hoisted_53, _toDisplayString(_unref(formatAmount)(quoteTotal.value)), 1)
              ])
            ])
          ]),
          _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
          _cache[61] || (_cache[61] = _createElementVNode("hr", null, null, -1)),
          _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1)),
          _cache[63] || (_cache[63] = _createElementVNode("p", { style: {"font-size":"13px","line-height":"20px"} }, " NSSI Accidental Damage Add-on Waiting Period: There is a 30 day waiting period for personal property claims resulting from accidental damage. Damages that occur within this waiting period will not be covered. ", -1)),
          _cache[64] || (_cache[64] = _createElementVNode("p", { style: {"font-size":"13px","line-height":"20px"} }, " PAYMENTS: You understand that your account will be charged automatically monthly, 4-pay or annually based on the “Payment Option” you selected. ", -1)),
          _cache[65] || (_cache[65] = _createElementVNode("p", { style: {"font-size":"13px","line-height":"20px"} }, " Fraud Notice: Any person who, with intent to defraud or knowing that he is facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement is guilty of insurance fraud. ", -1)),
          _createElementVNode("p", _hoisted_54, [
            _cache[53] || (_cache[53] = _createTextVNode(" By clicking \"Purchase Policy\", I acknowledge that I have read and understand the applicable ", -1)),
            _createElementVNode("a", {
              class: "javascriptlink",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showDisclosuresModal()), ["prevent"]))
            }, "notice of cancellation, "),
            _cache[54] || (_cache[54] = _createTextVNode(" & ", -1)),
            _createElementVNode("a", {
              class: "javascriptlink",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showPaymentAuthorizationModal()), ["prevent"]))
            }, "recurring payment authorization. "),
            _cache[55] || (_cache[55] = _createTextVNode(" I acknowledge that I am 18 years of age and have read and agree to the above terms. ", -1))
          ])
        ])
      ]),
      _cache[68] || (_cache[68] = _createElementVNode("div", { class: "spacer" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("button", {
        disabled: issuingPolicies.value,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage('quote-done')))
      }, " Purchase Policy ", 8, _hoisted_56)
    ]),
    _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
    _cache[70] || (_cache[70] = _createElementVNode("br", null, null, -1)),
    _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
    _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1)),
    _createVNode(BaseModal, { name: "DisclosuresModal" }, {
      default: _withCtx(() => [
        _createVNode(DisclosuresModal)
      ]),
      _: 1
    }),
    _createVNode(BaseModal, { name: "PaymentAuthorizationModal" }, {
      default: _withCtx(() => [
        _createVNode(PaymentAuthorizationModal)
      ]),
      _: 1
    })
  ]))
}
}

})